import React from 'react';
import startCase from 'lodash/startCase';
import {getTextImagesFromType, getStatusImages, getStatusLabel} from '../../utils';
import { CREDENTIAL_TYPE_LABELS } from '../../constants';

const PassItem = ({item: {credentialType, status, firstName, lastName}, onClick}) => {
  const [textImage, textImage2x] = getTextImagesFromType(credentialType);
  const [statusImage, statusImage2x] = getStatusImages(status.toLowerCase());
  const showCredName = window.location.pathname === '/event/manually-assigned-credentials' || window.location.pathname.includes('/event/Round');

  return (
    <a className="panel-link" onClick={() => onClick()}>
      <div className="panel panel-card panel-card-sm">
        <div className={`card-brand card-${credentialType}`}>
          <img src={textImage} srcSet={`${textImage} 1x, ${textImage2x} 2x`} alt={`${credentialType} text`} />
        </div>
        <div className="panel-body">
          <h4>{firstName} {lastName}</h4>
          {showCredName && CREDENTIAL_TYPE_LABELS[credentialType] && (
            <h5 className="card-cred-type">{ CREDENTIAL_TYPE_LABELS[credentialType]['singular'] }</h5>
          )}
          <span>
            <img src={statusImage} srcSet={`${statusImage} 1x, ${statusImage2x} 2x`} alt={`${status}`} />
            {' '}
            {startCase(getStatusLabel(status))}
          </span>
          <div className="icon-gray_arrow_forward panel-cta"></div>
        </div>
      </div>
    </a>
  );
};

export default PassItem;



// WEBPACK FOOTER //
// ./src/components/Credentials/PassItem.js